// const axios = require('axios')



// const { Data_formattata } = require('../Funzioni_comuni')
function Data_formattata1(newDate) {
//  console.log('aaaaaaaaaaaaaaaaaaaaaaa')
//  console.log(newDate)
  
  let dateVariable = new Date(newDate);
  if (dateVariable == 'Invalid Date') {

     console.log('NON DATA ')
     
     return ''
  }

  const months = {
    0: 'Gennaio',
    1: 'Febbraio',
    2: 'Marzo',
    3: 'Aprile',
    4: 'Maggio',
    5: 'Giugno',
    6: 'Luglio',
    7: 'Agosto',
    8: 'Settembre',
    9: 'Ottobre',
    10: 'Novembre',
    11: 'Dicembre',
  }
  const days = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab']
//  const d = newDate
//  console.log('YYYYYYYYYYYYYYYYYYYYYYYYYYYYY  NON DATA ')
  
  const year = dateVariable.getFullYear()
  const date = dateVariable.getDate()
//  const monthIndex = dateVariable.getMonth()
  const monthName = months[dateVariable.getMonth()]
  const dayName = days[dateVariable.getDay()] // Thu
  const formatted = `${dayName}, ${date} ${monthName} ${year}`
  return formatted.toString()
} 
exports.Data_formattata1 = Data_formattata1;


